import { staticReportsQueries } from "constants/reports";
import dayjs from "dayjs";
import queryString from "query-string";

import { ReportsQueries, UrlQueryParams } from "../store/types";
import syncReportTableColumn from "./sync-report-table-column";

export const queriesStringToDate = ({
  dateRange,
  secondaryDateRange,
  ...restQueries
}: Partial<ReportsQueries<string>>): Partial<ReportsQueries<string>> => {
  const queries: Partial<ReportsQueries<string>> = {
    ...restQueries
  };

  if (dateRange) {
    queries.dateRange = { value: dateRange.value };

    if (dateRange.from) {
      queries.dateRange.from = dayjs(new Date(dateRange.from)).toISOString();
    }

    if (dateRange.to) {
      queries.dateRange.to = dayjs(new Date(dateRange.to)).toISOString();
    }
  }

  if (secondaryDateRange) {
    queries.secondaryDateRange = { value: secondaryDateRange.value };

    if (secondaryDateRange.from) {
      queries.secondaryDateRange.from = dayjs(new Date(secondaryDateRange.from)).toISOString();
    }

    if (secondaryDateRange.to) {
      queries.secondaryDateRange.to = dayjs(new Date(secondaryDateRange.to)).toISOString();
    }
  }

  return queries;
};

const handleBackwardCompatibility = (queries: Record<string, any>): Partial<ReportsQueries<string>> => {
  const newQueries = { ...queries };
  if (queries.cubicsSnapDataFormation) {
    newQueries.cubicSnapshot = queries.cubicsSnapDataFormation;
  }
  if (queries.cubicsDealDataFormation) {
    newQueries.cubicDeal = queries.cubicsDealDataFormation;
  }
  return newQueries;
};

// Route-specific keys that should only be kept in the URL on their respective routes
const routeSpecificKeys: Record<string, string[]> = {
  "/main/benchmark": ["benchmarkTableColumns", "benchmarkIndexName", "graphBenchmark"],
  "/main/reports/cashflow": ["cashflowSetId"]
};

const getKeysToExclude = (pathname: string): string[] => {
  const keysToKeep = Object.entries(routeSpecificKeys)
    .filter(([route]) => pathname.startsWith(route))
    .flatMap(([, keys]) => keys);

  const allRouteKeys = Object.values(routeSpecificKeys).flat();
  return allRouteKeys.filter((key) => !keysToKeep.includes(key));
};

export const reportStateFromQueries = (queriesString: string, pathname?: string): ReportsQueries | null => {
  const filteredEmail = queriesString.replace(/(email.+)\+/g, "%2B");
  const queryParams: UrlQueryParams = queryString.parseUrl(filteredEmail).query;

  try {
    if (queryParams.reports) {
      let reportsObject = queriesStringToDate(JSON.parse(queryParams.reports));
      reportsObject = handleBackwardCompatibility(reportsObject);
      const excludeKeys = getKeysToExclude(pathname || window.location.pathname);
      excludeKeys.forEach((key) => delete reportsObject[key as keyof typeof reportsObject]);
      const queries = { ...staticReportsQueries, ...reportsObject };
      queries.reportTableColumns = syncReportTableColumn(queries, queries.reportTableColumns);
      return queries;
    }
  } catch (e) {
    console.error(e);
    return staticReportsQueries;
  }

  return null;
};
